import React, { useState } from "react";
import { Link } from "react-router-dom";
import { COUNTRY_DIAL_CODES } from "./countryDialCodes";
import "./ContactUs.css"; // keep this

const ContactUs = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneCountry: "+47", // default Norway
    phoneNumber: "",
    company: "",
    subject: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
      name: `${formData.firstName} ${formData.lastName}`.trim(),
      phone: `${formData.phoneCountry} ${formData.phoneNumber}`.trim(),
    };
    console.log("Contact form submitted:", payload);
    // TODO: send `payload` to your API
  };

  return (
    <div className="row clearfix">
      <div className="col-sm-2"></div>
      <div className="col-sm-9" style={{ padding: "0" }}>
        <div className="container-fluid">
          <div className="block-header">
            <div className="row clearfix">
              <div className="col-md-6 col-sm-12">
                <h2>Contact Us</h2>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Contact Us
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>

          <div className="row clearfix contact-row">
            {/* LEFT COLUMN */}
            <div className="col-xl-8 col-lg-8 col-md-12">
              <div className="card contact-card">
                <div className="header">
                  <h2>Get in Touch</h2>
                  <p className="text-muted">
                    Have questions about our cybersecurity services? Need expert
                    consultation? We're here to help protect your digital presence.
                  </p>
                </div>

                <div className="body contact-form">
                  <form onSubmit={handleSubmit} noValidate>
                    {/* First / Last Name on one row */}
                    <div className="form-row-2">
                      <div className="form-group">
                        <label htmlFor="firstName">First Name *</label>
                        <input
                          id="firstName"
                          type="text"
                          name="firstName"
                          className="form-control"
                          placeholder="First Name"
                          value={formData.firstName}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="lastName">Last Name *</label>
                        <input
                          id="lastName"
                          type="text"
                          name="lastName"
                          className="form-control"
                          placeholder="Last Name"
                          value={formData.lastName}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>

                    {/* Email (full width) */}
                    <div className="form-group">
                      <label htmlFor="email">Email *</label>
                      <input
                        id="email"
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="your.email@company.com"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                      />
                    </div>

                    {/* Phone (country + number) */}
                    <div className="form-group">
                      <label htmlFor="phoneNumber">Phone</label>
                      <div className="phone-split">
                        <select
                          name="phoneCountry"
                          className="form-control"
                          value={formData.phoneCountry}
                          onChange={handleInputChange}
                          aria-label="Country dial code"
                        >
                          {COUNTRY_DIAL_CODES.map((c) => (
                            <option key={`${c.iso2}-${c.dialCode}`} value={c.dialCode}>
                              {c.dialCode} ({c.name})
                            </option>
                          ))}
                        </select>

                        <input
                          id="phoneNumber"
                          type="tel"
                          name="phoneNumber"
                          className="form-control"
                          placeholder="Phone number"
                          value={formData.phoneNumber}
                          onChange={handleInputChange}
                          pattern="[\d\s\-()+]+"
                        />
                      </div>
                      <small className="text-muted">
                        Include area code if applicable. Example: 21 23 45 67
                      </small>
                    </div>

                    {/* Company */}
                    <div className="form-group">
                      <label htmlFor="company">Company *</label>
                      <input
                        id="company"
                        type="text"
                        name="company"
                        className="form-control"
                        placeholder="Company"
                        value={formData.company}
                        onChange={handleInputChange}
                        required
                      />
                    </div>

                    {/* Subject */}
                    <div className="form-group">
                      <label htmlFor="subject">Subject *</label>
                      <input
                        id="subject"
                        type="text"
                        name="subject"
                        className="form-control"
                        placeholder="Subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        required
                      />
                    </div>

                    {/* Message */}
                    <div className="form-group">
                      <label htmlFor="message">Message *</label>
                      <textarea
                        id="message"
                        name="message"
                        className="form-control"
                        rows="6"
                        placeholder="Write your message…"
                        value={formData.message}
                        onChange={handleInputChange}
                        required
                      />
                    </div>

                    {/* ORIGINAL BUTTON */}
                    <button type="submit" className="btn btn-primary btn-round">
                      Send Message
                    </button>
                  </form>
                </div>
              </div>
            </div>

            {/* RIGHT COLUMN */}
            <div className="col-xl-4 col-lg-4 col-md-12 side-col">
              <div className="card side-card">
                <div className="header">
                  <h2>Contact Information</h2>
                </div>
                <div className="body">
                  <div className="contact-info mb-4">
                    <h6><i className="fa fa-phone mr-2"></i> Phone</h6>
                    <p className="text-muted">123</p>
                  </div>

                  <div className="contact-info mb-4">
                    <h6><i className="fa fa-envelope mr-2"></i> Email</h6>
                    <p className="text-muted">abc@iodin.com</p>
                  </div>

                  <div className="contact-info mb-4">
                    <h6><i className="fa fa-shield mr-2"></i> Emergency Support</h6>
                    <p className="text-muted">
                      24/7 Expert Advisory<br />
                      emergency@iodin.com<br />
                      +1 (555) 911-CYBER
                    </p>
                  </div>

                  <hr />

                  <div className="contact-info">
                    <h6><i className="fa fa-clock mr-2"></i> Business Hours</h6>
                    <p className="text-muted mb-1">Monday - Friday: 9:00 AM - 6:00 PM</p>
                    <p className="text-muted mb-1">Saturday: 10:00 AM - 4:00 PM</p>
                    <p className="text-muted">Sunday: Emergency Support Only</p>
                  </div>
                </div>
              </div>

              <div className="card side-card">
                <div className="header">
                  <h2>Quick Links</h2>
                </div>
                <div className="body">
                  <ul className="list-unstyled">
                    <li><Link to="/kb#faq" className="text-primary">Frequently Asked Questions</Link></li>
                    <li><Link to="/kb#platform" className="text-primary">Platform Documentation</Link></li>
                    <li><Link to="/services" className="text-primary">Valkyrie Services</Link></li>
                    <li><Link to="/company-profile" className="text-primary">About iOdin</Link></li>
                  </ul>
                </div>
              </div>
            </div>
            {/* END RIGHT COLUMN */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
